console.log("ENV: ", process.env.NODE_ENV);

const isProduction = "production" === process.env.NODE_ENV;

export default {
    STORAGE_KEY_JWT: "jwt",
    API_URL: isProduction ? "https://network.juniti.app/api/v1" : "https://okja-dev.tdsoftware.de/api/v1",
    // API_URL: "http://localhost:8080/api/v1",
    SUPER_ADMIN_ROLE: "ROLE_SUPER_ADMIN",
    ADMIN_ROLE: "ROLE_ADMIN",
    MANAGER_ROLE: "ROLE_MANAGER",
    COMMUNITY_MANAGER_ROLE: "ROLE_COMMUNITY_MANAGER"
};
